<template>
  <div class="trf-totalizadores-time">
    <div class="trf-totalizadores-time-header mb-4">
      <p class="trf-totalizadores-time-header-titulo is-size-4 mb-4">Time</p>
      <div class="trf-totalizadores-time-header-filtros columns is-align-items-flex-end">
        <div class="column is-3">
          <TrfSelect 
            :options="optionsTratadasParaSort"
            label="Ordenar por"
            idSelect="select-ordem-card-time"
            @valueSelect="(value) => (filtroOrdem = value)"
            placeholder="Selecione uma ordenação"
            ref="filtroOrdenacao"
          />
        </div>
        <div class="column is-6">
          <TrfInput 
            type="text"
            label="Pesquisar"
            placeholder="Buscar usuário por nome"
            :required="false"
            ref="usuarioNome"
            v-model="filtroNome"
          />
        </div>
        <div class="column is-offset-2 is-1 mb-4 is-flex is-justify-content-flex-end">
          <TrfButton 
            type="button"
            nome="Filtrar"
            ref="btnFiltrar"
            classCor="is-primary"
            :class="{ 'is-loading': TrfMixInfiniteScrollCustomConfig.listaDeUsuarios.listagemCarregando }"
            @click="async () => await aplicarFiltroLocal()"
          />
        </div>
      </div>
    </div>
    <div class="trf-totalizadores-time-listagem is-relative">
      <TrfGlobalLoader type="overlay" v-if="primeiroCarregamento || (reloading && listaDeUsuarios.length > 0)" />
      <p class="trf-totalizadores-time-listagem-vazio is-size-3" v-if="!primeiroCarregamento && listaDeUsuarios.length == 0">Não há informações</p>
      <div class="columns is-multiline is-3">
        <template v-for="(usuario, index) in listaDeUsuarios" :key="index">
          <div class="column is-3">
            <TrfCardTotalizadorUsuario @dadosEnviados="showModal" @passarListaHistoricos="obterListaHistoricos" :dashboardUser="usuario" :statusIgnorados="statusIgnoradosNoCard" :filtrosGlobais="filtrosGlobais" />
          </div>
        </template>
      </div>
      <div v-if="TrfMixInfiniteScrollCustomConfig.listaDeUsuarios.listagemCarregando && !TrfMixInfiniteScrollCustomConfig.listaDeUsuarios.paginacaoFinalizada && !reloading">
        <span class="button is-large is-fullwidth is-loading trf-is-borderless"></span>
      </div>
    </div>
    <TrfSimpleModal :titulo="modalListagemTitulo" :isAtivo="isModalDetalhesActive" @close="fecharModal" :isModalPersonalizado="true">
          <div id="conteudo-modal-listagem-time" class="modal-list-content pt-0">
            <div v-if="isListagemHistoricoTarefasEmpty">
              <p class="has-text-centered">
                <span class="button is-loading pl-2 pr-2 is-inline-block is-size-1 mt-6 mb-6 is-white">
                </span>
              </p>
            </div>
            <div v-else id="conteudo-modal-listagem-time" class="modal-list-content pt-0"  @scroll="TrfMixAderirAoInfiniteScroll" style="max-height:60vh; max-width:1024px; width:100%;">
              <TrfSimpleTable :configuracaoDeColunas="listagemConfiguracao" 
                              :dados="listagemHistoricoTarefaTratada" 
                              :isCliente=false 
                              mensagemSemDados="Não há tarefas para este filtro."
                              :isSelectable="false"
                              :hasSlotLine="false"
                              :isToggleble="false"
                              togglebleItem="fases"
                              :isMultipleSelection="false">
                <template #tarefaNome={item}>
                  <p>
                    {{ item.nomePai? item.nomePai : item.nome }}<br />
                    <span v-if="!!item.nomePai" class="is-italic" style="font-size:0.9em;">Fase: {{ item.nome }}</span>
                  </p>
                </template>
              </TrfSimpleTable>
              <div v-if="this.TrfMixInfiniteScroll.listagemCarregando && !this.TrfMixInfiniteScroll.paginacaoFinalizada">
                <span class="button is-large is-fullwidth is-loading trf-is-borderless"></span>
              </div>
            </div>
          </div>
    </TrfSimpleModal>
  </div>
</template>
<script>
//TODO: Limitar caracteres no nome do usuário
import TrfGlobalLoader from '../../../../components/GlobalLoader';
import TrfCardTotalizadorUsuario from '../../../../components/Usuario/CardTotalizadorUsuario.vue';
import TrfInput from "../../../../components/Input";
import TrfButton from "../../../../components/Button";
import TrfSelect from "../../../../components/Select";
import TrfSimpleTable from "../../../../components/SimpleTable"
import TrfSimpleModal from "../../../../components/Modal/TrfSimpleModal.vue"
import { TrfMixinInfiniteScroll } from '../../../../mixins/infinitescroll';
import { configuracoesStore } from "../../../../stateManagement/configuracoes";
import { totalizadoresPorUsuarioService } from '../../../../service/totalizadores-por-usuario-service';
import { utils } from "../../../../util/utils"
import { statusTarefas } from '../../../../util/statusTarefas.utils'
import { toastUtils } from '../../../../util/toast.utils.js';

export default {
  name: "DashboardGestorTime",
  components: {
    TrfGlobalLoader,
    TrfCardTotalizadorUsuario,
    TrfInput,
    TrfButton,
    TrfSelect,
    TrfSimpleModal,
    TrfSimpleTable
  },
  mixins: [TrfMixinInfiniteScroll],
  props: {
    filtrosGlobais: {}
  },
  data() {
    return {
      filtrosLocais: {},
      primeiroCarregamento: true,
      reloading: false,
      listaDeUsuarios: [],
      totalDePaginas: 1,
      filtroNome: '',
      filtroOrdem: null,
      opcoesFiltroOrdem: [
        {label: "Sem ordenação", value: {"sort[ASC]": "responsavelNome"}},
        {label: "Mais tarefas a fazer", value: {'sort[DESC]': "aVencer"}},
        {label: "Menos tarefas a fazer", value: {'sort[ASC]': "aVencer"}},
        {label: "Mais tarefas atrasadas", value: {'sort[DESC]': "atrasadas"}},
        {label: "Menos tarefas atrasadas", value: {'sort[ASC]': "atrasadas"}},
        {label: "Mais tarefas concluídas", value: {'sort[DESC]': "concluidas"}},
        {label: "Menos tarefas concluídas", value: {'sort[ASC]': "concluidas"}},
        {label: "Mais tarefas paralisadas", value: {'sort[DESC]': "paralisadas"}},
        {label: "Menos tarefas paralisadas", value: {'sort[ASC]': "paralisadas"}},
        //{label: "Mais tarefas com risco de multas", value: {'sort[DESC]': "riscoDeMulta"}}
        //{label: "Menos tarefas com risco de multas", value: {'sort[ASC]': "riscoDeMulta"}}
      ],
      listaHistoricoTarefas: [],
      isModalDetalhesActive:false,
      modalListagemTitulo: 'Meu titulo',
      usuarioIdSelecionado: null,
      textoStatusAtual: [],
      obterListaHistoricos: null,
    };
  },
  methods: {
    async aplicarFiltroLocal() {
      let objeto = {};
      let ordem = {"sort[ASC]": "responsavelNome"};

      if(!!this.filtroNome) {
        objeto['responsavelNome[iLike]'] = "%"+this.filtroNome+"%";
      }
      if(!!this.filtroOrdem) {
        ordem = this.filtroOrdem;
      }

      objeto = {
        ...objeto,
        ...ordem
      }

      this.filtrosLocais = objeto;
      const recarregarLista = await this._carregarListagem(true);
    },
    async _carregarListagem(resetar) {
      try {
        if (!!resetar) {
          this.reloading = true;
          this.resetarPaginacaoListaDeUsuarios();
        }
        this.TrfMixInfiniteScrollCustomConfig.listaDeUsuarios.listagemCarregando = true;

        const paginaDeUsuarios = await totalizadoresPorUsuarioService.listar(this.filtrosParaRequest);

        if(!!resetar) {
          this.listaDeUsuarios = [...paginaDeUsuarios.data];
        } else {
          this.listaDeUsuarios = [...this.listaDeUsuarios, ...paginaDeUsuarios.data];
        }

        const total = parseInt(paginaDeUsuarios.totalDeItens);
        this.TrfMixInfiniteScrollCustomConfig.listaDeUsuarios.paginacaoFinalizada = total == this.listaDeUsuarios.length;
      } catch (e) {
        console.error(e);
      }
      this.TrfMixInfiniteScrollCustomConfig.listaDeUsuarios.listagemCarregando = false;
      this.reloading = false;
      if(this.primeiroCarregamento) {
        this.iniciarEventoDeScroll();
        this.primeiroCarregamento = false;
      }
    },
    async listarHistoricoTarefas() {

        let filtro = {...this.filtrosGlobais};
        filtro["responsavelId"] = this.usuarioIdSelecionado;
        filtro.pagina =  this.TrfMixInfiniteScroll.page  || 1;
        filtro.limit = this.TrfMixInfiniteScroll.limit  || 20;
        filtro.tarefaCliente = false;
        filtro["sort[ASC]"] = "nome";

        if (filtro["responsavelId"] == 0) {
          filtro["responsavelId[Is]"] = null;
          delete filtro["responsavelId"];
        }
        
        filtro.status = statusTarefas.obterCodigo(this.textoStatusAtual);
        const {historicoDashboardService} = await import("../../service/historico-dashboard-service.js");
        const listaDeHistoricos = await historicoDashboardService.listarHistorico(filtro);
        this.listaHistoricoTarefas =  [...this.listaHistoricoTarefas, ...listaDeHistoricos.data];
        const total = parseInt(listaDeHistoricos.totalDeItens);
        this.TrfMixInfiniteScroll.paginacaoFinalizada = total == this.listaHistoricoTarefas.length;
        this.limparObjetoFiltro(filtro);
    },

    async listaDeUsuariosIncrementarPagina(page, limit) {
      this.TrfMixInfiniteScrollCustomConfig.listaDeUsuarios.page = page+1;
      this.TrfMixInfiniteScrollCustomConfig.listaDeUsuarios.limit = limit;
      await this._carregarListagem(false);
    },
    resetarPaginacaoListaDeUsuarios() {
      this.TrfMixInfiniteScrollCustomConfig.listaDeUsuarios.page = 1;
      this.TrfMixInfiniteScrollCustomConfig.listaDeUsuarios.limit = 20;
      this.TrfMixInfiniteScrollCustomConfig.listaDeUsuarios.paginacaoFinalizada = false;
      totalizadoresPorUsuarioService.abortarUltimoRequest('get');
    },
    async TrfMixIncrementarPagina(page, limit) {
      this.TrfMixInfiniteScroll.page = page+1;
      this.TrfMixInfiniteScroll.limit = limit;
      await this.listarHistoricoTarefas();
    },
    resetarPaginacao() {
      this.TrfMixInfiniteScroll.page  =  1;
      this.TrfMixInfiniteScroll.limit = 20;
      this.TrfMixInfiniteScroll.paginacaoFinalizada = false;
      this.listaHistoricoTarefas  = [];
    },
    aderirAoScrollCustomizado(event) {
      this.TrfMixAderirAoInfiniteScroll(event, 'listaDeUsuarios');
    },
    iniciarEventoDeScroll() {
      document.addEventListener('scroll', this.aderirAoScrollCustomizado);
    },

    removerEventoDeScroll() {
      document.removeEventListener('scroll', this.aderirAoScrollCustomizado)
    },
    fecharModal() {
        this.isModalDetalhesActive = false;
        this.listaHistoricoTarefas = [];
        const conteudoComScroll = document.getElementById('conteudo-modal-listagem-time');
        if(!!conteudoComScroll) {
          conteudoComScroll.scrollTo(0, 0);
        }
        this.resetarPaginacao();
    },
    async showModal(texto,dados) {
        const textoStatusAtualTitulo = statusTarefas.obterTexto(texto);
        if (dados.nome == null) {
          this.modalListagemTitulo = `Sem responsável - Tarefas com status ${textoStatusAtualTitulo.toLowerCase()}`;
        } else {
          this.modalListagemTitulo = `${dados.nome} - Tarefas com status ${textoStatusAtualTitulo.toLowerCase()}`;
        } 
        this.textoStatusAtual = texto;
        this.usuarioIdSelecionado = dados.usuarioId;
        this.isModalDetalhesActive = true;
        try {
          await this.listarHistoricoTarefas();
        } catch (e) {
          console.error(`ERR: ${e}`);
          toastUtils.dangerToast("Ocorreu um erro ao carregar os dados.\nVerifique sua conexão e tente novamente em alguns minutos!")
          this.fecharModal();
        }
      },
      limparObjetoFiltro(filtro) {
        for (const key in filtro) {
          if (!(key == 'dataInicial' || key == 'dataFinal' || key == 'sort[ASC]'))
            delete filtro[key];
        }
      },
      converterTarefaBackParaExibicao(tarefa) {
      const tarefaFormatada = {
        nome: tarefa.nome,
        empresa: `${tarefa.empresa.externoId} - ${tarefa.empresa.nome}`,
        prazoEntrega: utils.formatarDataParaExibicaoNoDataTable(tarefa.prazoEntrega),
        departamento: !!tarefa?.departamentoPadrao && !!!tarefa?.departamento? tarefa?.departamentoPadrao?.nome : tarefa?.departamento?.nome,
        responsavel: !!tarefa.responsavel && tarefa.responsavel.nome 
      }

      return tarefaFormatada;
    },
    converterFaseBackParaExibicao(tarefa, fase) {
      const responsavel = this.responsaveis.find(responsavel => {
        return responsavel.value == fase.responsavelId;
      })
      const faseFormatada = {
        nome: fase.nome,
        nomePai: tarefa.nome,
        empresa: `${tarefa.empresa.externoId} - ${tarefa.empresa.nome}`,
        prazoEntrega: utils.formatarDataParaExibicaoNoDataTable(tarefa.prazoEntrega),
        departamento: this.exibirDepartamentoTabelaFase(fase),
        responsavel: responsavel?.label ? responsavel.label : '---',
      }

      return faseFormatada;
    },
    exibirDepartamentoTabelaFase(item) {
      if (!!!item.departamentoId) return "---";
      const departamento = this.dListaDepartamentos.find((departamento) => {
        return departamento.value == item.departamentoId;
      });
      return departamento.label;
    }
  },
  computed: {
    filtrosParaRequest() {
      
      const filtros = {
        "sort[ASC]": "responsavelNome",
        ...this.filtrosGlobais,
        ...this.filtrosLocais,
        pagina: this.TrfMixInfiniteScrollCustomConfig.listaDeUsuarios.page || 1,
        limit: this.TrfMixInfiniteScrollCustomConfig.listaDeUsuarios.limit || 20,
        tarefaCliente: false
      };

      if(!!filtros["sort[DESC]"] && !!filtros["sort[ASC]"]) {
        delete filtros["sort[ASC]"]
      }

      return filtros
    },
    statusIgnoradosNoCard() {
      const ignorar = ["riscoDeMulta"];
      if(!configuracoesStore.GerarBaixaPorLeitura) {
        ignorar.push("enviadas");
      };
      return ignorar;
    },
    dListaDepartamentos(){
      return this.listaDepartamentos? [...this.listaDepartamentos] : []
    },
    optionsTratadasParaSort() {
      const options = [
        ...this.opcoesFiltroOrdem
      ]
      if(configuracoesStore.GerarBaixaPorLeitura) {
        options.push({label: "Mais tarefas enviadas", value: {'sort[DESC]': "enviadas"}});
        options.push({label: "Menos tarefas enviadas", value: {'sort[ASC]': "enviadas"}});
      };
      return options
    },
    totalizadoresValidos() {
        const totalizadores = Object.assign({}, this.dashboardUser.totalizador);
        this.statusIgnorados.forEach(status => {
          if(totalizadores[status] != null) {
            delete totalizadores[status];
          }
        })
        return totalizadores;
    },
    listagemConfiguracao() {
      return [
          {
            titulo: "Nome da tarefa",
            nome: "tarefaNome",
            referencia: ['nome'],
            divisor: "",
            customStyle: "width: 325px;",
            slot: true
          },
          {
            titulo: "Nome da empresa",
            referencia: ['empresa'],
            divisor: ` - `,
            customStyle: "width:255px;"
          },
          {
            titulo: "Data de entrega",
            referencia: ['prazoEntrega'],
            divisor: "",
            customStyle: "width: 140px;"
          },
          {
            titulo: "Departamento",
            referencia: ['departamento'],
            divisor: "",
            customStyle: "width: 200px;"
          }
        ]
      },
      listagemHistoricoTarefaTratada() {
        if(!!!this.listaHistoricoTarefas) return [];
        const listagemTratada = [];

        this.listaHistoricoTarefas.forEach(dado => {
        let dadoTratado;
        if(dado.fases != null) {
          dado.fases.forEach(fase => {
            dadoTratado = this.converterFaseBackParaExibicao(dado, fase);
            listagemTratada.push(dadoTratado);
          })
        } else {
          dadoTratado = this.converterTarefaBackParaExibicao(dado);
          listagemTratada.push(dadoTratado);  
        }
      })

        return listagemTratada;
      },
      isListagemHistoricoTarefasEmpty() {
        return this.listaHistoricoTarefas.length == 0;
      }
  },
  created() {
    this.TrfMixInfiniteScrollCustomConfig.listaDeUsuarios = {
      page: 1,
      limit: 20,
      paginacaoFinalizada: false,
      listagemCarregando: false,
      incrementFn: (page, limit) => this.listaDeUsuariosIncrementarPagina(page, limit)
    }
  },
  deactivated() {
    this.removerEventoDeScroll();
    totalizadoresPorUsuarioService.abortarUltimoRequest('get');
  },
  beforeUnmounted() {
    this.removerEventoDeScroll();
    totalizadoresPorUsuarioService.abortarUltimoRequest('get');
  },
};
</script>
<style lang="scss" scoped>
.trf-totalizadores-time {
  &-listagem {
    min-height:120px;
  }
}
.columns.is-0 > .column {
  padding-left: 0;
  padding-right: 0;
}
.columns.is-1 > .column {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.columns.is-2 > .column {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.columns.is-3 > .column {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.columns.is-4 > .column {
  padding-left: 1rem;
  padding-right: 1rem;
}
.columns.is-5 > .column {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.columns.is-6 > .column {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.columns.is-7 > .column {
  padding-left: 1.75rem;
  padding-right: 1.75rem;
}
.columns.is-8 > .column {
  padding-left: 2rem;
  padding-right: 2rem;
}
.modal-list-content {
  overflow: auto;
  max-height: 70vh;
}
</style>